import React from "react";
import PriceList from "./imgs/price-list.jpg";
import OurService from "./imgs/our-service.jpg";
import OurWorks from "./imgs/our-works.jpg";
import OurServiceMobile from "./imgs/our-service-mobile-view.jpg";
import OurWorksMobile from "./imgs/our-works-mobile-view.jpg";

import "./partner.css";

class Partner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.setState({
            isMobile: Boolean(window.innerWidth <= 767),
        });
    };

    render() {
        const { isMobile } = this.state;
        return (
            <div className="partner-info">
                <div>
                    <img
                        src={PriceList}
                        className="partner-image price-image"
                    />
                </div>
                <div>
                    <img
                        src={isMobile ? OurServiceMobile : OurService}
                        className="partner-image "
                    />
                </div>
                <div>
                    <img
                        src={isMobile ? OurWorksMobile : OurWorks}
                        className="partner-image"
                    />
                </div>
            </div>
        );
    }
}

export default Partner;



// WEBPACK FOOTER //
// ./src/Partner/index.jsx